export default __webpack_public_path__ + "static/icon_organize.71bc3bbadd33f61afd8629826416df5b.png";